import { AxiosError } from "axios";
import { useAuthorizationContext, useClientPortalConfigContext } from "../../../../context";
import { AccountModel, LoginModel, ApiErrorResponse } from "types/generated/models";
import { LoginType } from "./LoginDialogForm.helpers";
import { UseFormReturn } from "react-hook-form";
import { usePostMutation } from "hooks/useClientPortalQuery";
import { useAnalytics } from "hooks/useAnalytics";

export interface IUserLoginHook {
    isPending: boolean;
    login: (values: LoginType, returnUrl: string, loginSuccess?: () => void) => Promise<void>;
}

export function useClientPortalUserLogin(form: UseFormReturn<LoginType>): IUserLoginHook {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { loginUser } = useAuthorizationContext();
    const { track } = useAnalytics();

    const { setError } = form;

    const { mutateAsync, isPending } = usePostMutation<AccountModel, AxiosError, LoginModel>({
        url: `/api/v1/${clientPortalGuid}/Auth/LogIn`,
    });

    const login = async (values: LoginType, returnUrl: string, loginSuccess?: () => void) => {
        try {
            const response = await mutateAsync({ ...values, returnUrl } as LoginModel);
            if (response) {
                loginUser(response);
                track("user_login", { method: "email" });
                loginSuccess?.();
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                const typedError = error as AxiosError<ApiErrorResponse>;
                if (typedError.response.status === 400 || typedError.response.status === 401) {
                    setError("root", {
                        type: "manual",
                        message: typedError.response?.data?.message,
                    });

                    return;
                }
            }
        }
    };

    return {
        isPending,
        login,
    };
}
